import { render, staticRenderFns } from "./auction_asset.vue?vue&type=template&id=8343c824&scoped=true"
import script from "./auction_asset.vue?vue&type=script&lang=js"
export * from "./auction_asset.vue?vue&type=script&lang=js"
import style0 from "./auction_asset.vue?vue&type=style&index=0&id=8343c824&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8343c824",
  null
  
)

export default component.exports